<template>
    <div class="login-modal-mask" :class="[modalClass]">
        <div class="account-pages">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card">
                            <div class="card-header pt-4 pb-4 text-center bg-primary">
                                <a href="index.html">
                                    <span>
                                        <img src="@/client/img/sp_logo.png" />
                                    </span>
                                </a>
                            </div>
                            <div class="card-body p-4">
                                <div class="text-center w-75 m-auto">
                                    <h4
                                        class="text-dark-50 text-center mt-0 font-weight-bold"
                                    >Sign In</h4>
                                    <p class="text-muted mb-4">Please sign in to continue.</p>
                                </div>

                                <form method="POST" @submit.prevent="login()">
                                    <div class="form-group">
                                        <label for="emailaddress">E-mail address</label>
                                        <input
                                            id="email"
                                            type="email"
                                            class="form-control"
                                            name="email"
                                            v-model="form.email"
                                            required
                                            autocomplete="email"
                                            autofocus
                                            :class="[errorInputClass('email')]"
                                            :disabled="loading"
                                        />

                                        <form-error-label
                                            :target="errors['email']"
                                            error-class="invalid-feedback"
                                            role="alert"
                                        ></form-error-label>
                                    </div>

                                    <div class="form-group">
                                        <label for="password">Password</label>
                                        <input
                                            id="password"
                                            type="password"
                                            class="form-control"
                                            name="password"
                                            required
                                            autocomplete="current-password"
                                            v-model="form.password"
                                            :class="[errorInputClass('password')]"
                                            :disabled="loading"
                                        />

                                        <form-error-label
                                            :target="errors['password']"
                                            error-class="invalid-feedback"
                                            role="alert"
                                        ></form-error-label>
                                    </div>

                                    <div class="form-group mb-3">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="checkbox-signin"
                                                v-model="form.remember"
                                                :disabled="loading"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="checkbox-signin"
                                            >Remember Me</label>
                                        </div>
                                    </div>

                                    <div
                                        class="message"
                                        :class="{'error': message_error }"
                                        role="alert"
                                        v-if="message"
                                        v-text="message"
                                    ></div>

                                    <div class="form-group mb-0 text-center">
                                        <button
                                            class="btn btn-primary btn-submit"
                                            type="submit"
                                            :disabled="loading"
                                        >
                                            <div class="spinner loading white" v-if="loading"></div>Login
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <!-- end card-body -->
                        </div>
                        <!-- end card -->
                    </div>
                    <!-- end col -->
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </div>
        <!-- end page -->
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import FormErrorLabel from "@/ui/FormErrorLabel";

export default {
    components: {
        FormErrorLabel
    },
    data() {
        return {
            form: {
                email: null,
                password: null,
                remember: false
            },
            errors: [],
            message: null,
            message_error: false,
            loading: false
        };
    },
    methods: {
        // tryLogin() {
        //     this.setShowingLoginModal(false);
        //     this.setAuthenticated(true);
        // },

        async login() {
            this.message = null;
            this.message_error = false;
            this.errors = [];
            this.loading = true;

            try {
                let res = await this.tryLogin({
                    email: this.form.email,
                    password: this.form.password,
                    remember: this.form.remember
                });
                console.log(res);

                if (res.data && res.data.status == "ok") {
                    // this.setShowingLoginModal(false);

                    this.clearForm();

                    if (this.loginModalResolveCallback) {
                        this.loginModalResolveCallback();
                    }

                    // if the promise was resovled, we hide the login modal and clear all the callbacks
                    this.showLoginModal({
                        show: false
                    });
                }
            } catch (e) {
                let res = e.response;
                console.log(e);

                if (res.status == 422) {
                    // console.log(res.message);
                    this.errors = res.data.errors;
                }
                this.message = res.data.message;
                this.message_error = true;
            } finally {
                this.loading = false;
            }
        },
        clearForm() {
            this.form.email = null;
            this.form.password = null;
            this.form.remember = null;
        },
        errorInputClass(input) {
            return this.errors[input] ? "is-invalid" : null;
        },
        ...mapActions("auth", ["tryLogin", "showLoginModal"]),
        ...mapMutations("auth", ["setShowingLoginModal", "setAuthenticated"])
    },
    computed: {
        modalClass() {
            return !this.authenticated ? "unauthenticated" : null;
        },
        ...mapState("auth", [
            "authenticated",
            "loginModalResolveCallback",
            "loginModalRejectCallback"
        ])
    }
};
</script>

<style lang='scss'>
.login-modal-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;

    background-color: rgba(0, 0, 0, 0.5);
    background: radial-gradient(
        circle,
        rgba(0, 0, 0, 0.1) 30%,
        rgba(0, 0, 0, 0.6)
    );

    &.unauthenticated {
        $base-color: #666666;
        background-color: $base-color;
        background: radial-gradient(
            circle,
            mix(black, $base-color, 10%) 30%,
            mix(black, $base-color, 60%)
        );
    }

    display: flex;
    align-items: center;

    & > .account-pages {
        width: 100%;

        .card-header {
            img {
                height: rem-calc(48);
            }
        }

        .card-body {
            .btn-submit {
                display: inline-flex;
                align-items: center;

                .spinner {
                    @include spinner();
                    margin-right: rem-calc(5);
                }
            }

            .message {
                text-align: center;
                margin-bottom: rem-calc(20);
            }
        }
    }
}
</style>